import "@/assets/css/style.css";
import "@/assets/css/tailwind.css";
import "@/assets/css/nprogress.css";
import "primeicons/primeicons.css";
import "vue3-toastify/dist/index.css";
import "floating-vue/dist/style.css";
import "@/assets/custom/custom.css";
import "../public/css/editor.css";

import { Dropdown, Menu, Tooltip as FTooltip, vClosePopper } from "floating-vue";

import { createApp } from "vue";
import App from "./App.vue";

import { pinia } from "@/shared/config/pinia/pinia-config.ts";
import router from "./shared/services/router";
import PrimeVue from "primevue/config";
import primevuePreset from "@/shared/config/primevue/primevue-preset-config.ts";

import Tooltip from "primevue/tooltip";
import { createHead } from "@unhead/vue/client";
import VueTheMask from "vue-the-mask";
import { i18n } from "@/shared/config/i18n/vue-i18n.ts";

import { getDefaultLanguage } from "@/shared/config/i18n/getDefaultLanguage";

const app = createApp(App);

getDefaultLanguage();
app.use(pinia);
app.use(router);
app.use(PrimeVue, primevuePreset);
app.use(createHead());
app.use(VueTheMask);
app.component("VDropdown", Dropdown);
app.component("VMenu", Menu);
app.component("VTooltip", FTooltip);
app.directive("close-popper", vClosePopper);
app.use(i18n);
app.directive("tooltip", Tooltip);

app.mount("#app");
